var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$hasPermission({ context: 'CUSTOMER_MANAGEMENT', action: 'update' }))?_c('v-btn',{staticClass:"primary my-btn tw-px-3 tw-py-2",attrs:{"rounded":""},on:{"click":_vm.getRouteEdit}},[_vm._v(_vm._s(_vm.$t("button.editCustomer")))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }